import React from 'react';

import Field from '../../Fields/Field';
import InputDateField from '../../Fields/InputDateField';
import InputTextField from '../../Fields/InputTextField';

import useReport from '../../../Hooks/useReport';
import TransactionReport from '../../../Utils/transactionReport';

import './TransactionsReportForm.scss';
import ActionButton from '../../Common/ActionButton';

function TransactionsReportForm({ facilityId }) {
  const {
    filterValues,
    downloadCSVReport,
    inputOnChange,
    resetFilters,
    isDownloadingCSV
  } = useReport(TransactionReport, facilityId);

  return (
    <div className="parkchirp--transactions-report--filter-form-container">
      <div className="parkchirp--transactions-report--filter-form">
        <h2>Transactions Report</h2>
        <div className="parkchirp--transactions-report--filter-inputs">
          <div className="parkchirp--transactions-report--filter-input-block">
            <Field label="Invoice/Credit ID"
              id="parkchirp--transactions-report-filter--invoice-id"
              layout="columns">
              <InputTextField inputId="parkchirp--transactions-report-filter--invoice-id"
                value={filterValues.modelId}
                onChange={inputOnChange('modelId')}
                editMode={true}
              />
            </Field>
          </div>
          <div className="parkchirp--transactions-report--filter-input-block">
            <Field label="Start Date"
              id="parkchirp--transactions-report-filter--start-date"
              layout="columns">
              <InputDateField inputId="parkchirp--transactions-report-filter--start-date"
                value={filterValues.startDate}
                onChange={inputOnChange('startDate')}
                editMode={true}
              />
            </Field>
            <Field label="End Date"
              id="parkchirp--transactions-report-filter--end-date"
              layout="columns">
              <InputDateField inputId="parkchirp--transactions-report-filter--end-date"
                value={filterValues.endDate}
                onChange={inputOnChange('endDate')}
                editMode={true}
              />
            </Field>
          </div>
          <div className="parkchirp--transactions-report--filter-input-block">
            <Field label="Sub. ID"
              id="parkchirp--transactions-report-filter--payor-id"
              layout="columns">
              <InputTextField inputId="parkchirp--transactions-report-filter--payor-id"
                value={filterValues.payorId}
                onChange={inputOnChange('payorId')}
                editMode={true}
              />
            </Field>
            <Field label="Sub. Name"
              id="parkchirp--transactions-report-filter--subscription_name"
              layout="columns">
              <InputTextField inputId="parkchirp--transactions-report-filter--subscription-name"
                value={filterValues.subscriptionName}
                onChange={inputOnChange('subscriptionName')}
                editMode={true}
              />
            </Field>
          </div>
        </div>
        <div className="parkchirp--transactions-report--filter-actions">
          <ActionButton label="Download Transaction Report"
            classNames={[ "button", "button-primary parkchirp--transactions-report--filter-action" ]}
            onClick={() => downloadCSVReport(true)}
            inProgressState={isDownloadingCSV}
          />
          <button type="button"
            className="button parkchirp--transactions-report--filter-action"
            onClick={resetFilters}
            >
            Reset
          </button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(TransactionsReportForm);